import { Component, inject, input } from '@angular/core';
import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { BreakpointObserver } from '@angular/cdk/layout';
import { map } from 'rxjs/operators';
import { HeaderLink } from '../../../interfaces';
import { SocialLinksComponent } from '../../social-links/social-links.component';
import { ProfileDataComponent } from '../profile-data/profile-data.component';
import { ProfileAvatarComponent } from '../profile-avatar/profile-avatar.component';
import { CommunityProfile } from '../../../utils/profile.utils';

@Component({
  selector: 'app-profile-info-view',
  templateUrl: './profile-info-view.component.html',
  styleUrls: ['./profile-info-view.component.scss'],
  imports: [ProfileDataComponent, ProfileAvatarComponent, SocialLinksComponent, AsyncPipe, NgTemplateOutlet],
})
export class ProfileInfoViewComponent {
  profile = input<CommunityProfile>();
  socialLinks = input<HeaderLink[] | null>(null);
  isLoading = input<boolean>(false);
  type = input<'primary' | 'secondary'>('primary');

  canDisplayMobileActions$ = inject(BreakpointObserver)
    .observe('(max-width: 767px)')
    .pipe(map(result => result.matches));
}
